module.exports = __webpack_public_path__ + "img/scene3-3D.3bde2dc0.gif";